/**
 * Permission options for VIVA HUB group management UI
 */

import {
  GROUP_APP_ACCESS,
  GROUP_LABELS,
  HUB_GROUPS,
  HUB_PRIMARY_GROUP_NAMES,
  HUB_SUPPLEMENTARY_GROUP_NAMES,
  GROUP_DEFAULT_PERMISSIONS,
} from './hub-groups.js'

export const HUB_ACCESS_PERMISSIONS = [
  {
    id: 'access_room_scheduler',
    label: 'Room Scheduler app',
    groups: [HUB_GROUPS.VIVA_ASSOCIATE, HUB_GROUPS.RENTER, HUB_GROUPS.HUB_ADMIN],
  },
  {
    id: 'access_profile',
    label: 'Profile app',
    groups: [HUB_GROUPS.VIVA_ASSOCIATE, HUB_GROUPS.RENTER, HUB_GROUPS.HUB_ADMIN],
  },
  {
    id: 'access_email_signature',
    label: 'Email Signature app',
    groups: [HUB_GROUPS.VIVA_ASSOCIATE, HUB_GROUPS.HUB_ADMIN],
  },
  { id: 'access_audit_log', label: 'Audit Log app', groups: [HUB_GROUPS.HUB_ADMIN] },
  {
    id: 'access_crm',
    label: 'CRM app',
    groups: [HUB_GROUPS.VIVA_ASSOCIATE, HUB_GROUPS.HUB_ADMIN, HUB_GROUPS.CRM_ASSIGNEE],
  },
  { id: 'access_whatsapp', label: 'WhatsApp messages app', groups: [HUB_GROUPS.HUB_ADMIN] },
  { id: 'access_contact', label: 'Contact app (legacy)', groups: [HUB_GROUPS.HUB_ADMIN] },
  {
    id: 'access_client_intake',
    label: 'Client Intake app (legacy)',
    groups: [HUB_GROUPS.HUB_ADMIN],
  },
  { id: 'access_settings', label: 'Users app', groups: [HUB_GROUPS.HUB_ADMIN] },
  { id: 'access_groups', label: 'Groups app', groups: [HUB_GROUPS.HUB_ADMIN] },
  {
    id: 'crm_lead_assignee',
    label: 'CRM case assignee (Assignee dropdown)',
    groups: [HUB_GROUPS.CRM_ASSIGNEE],
  },
  {
    id: 'crm_lead_notify',
    label: 'CRM case notifications (email alerts)',
    groups: [HUB_GROUPS.CRM_NOTIFY],
  },
  {
    id: 'crm_lead_nudge',
    label: 'CRM case nudge (friendly team reminders)',
    groups: [HUB_GROUPS.CRM_NUDGE],
  },
]

export const SCHEDULER_FEATURE_PERMISSIONS = [
  {
    id: 'manage_reservations',
    label: 'Manage reservations',
    groups: [HUB_GROUPS.VIVA_ASSOCIATE, HUB_GROUPS.RENTER, HUB_GROUPS.HUB_ADMIN],
  },
  { id: 'manage_rooms', label: 'Manage rooms', groups: [HUB_GROUPS.HUB_ADMIN] },
  { id: 'view_reports', label: 'View scheduler reports', groups: [HUB_GROUPS.HUB_ADMIN] },
  { id: 'manage_users', label: 'Manage users (scheduler)', groups: [HUB_GROUPS.HUB_ADMIN] },
  { id: 'manage_groups', label: 'Manage groups (scheduler)', groups: [HUB_GROUPS.HUB_ADMIN] },
]

export const ALL_PERMISSION_OPTIONS = [
  ...HUB_ACCESS_PERMISSIONS,
  ...SCHEDULER_FEATURE_PERMISSIONS,
]

/** Preset group templates for quick creation */
export const GROUP_PRESETS = [...HUB_PRIMARY_GROUP_NAMES, ...HUB_SUPPLEMENTARY_GROUP_NAMES].map(
  (name) => ({
    name,
    label: GROUP_LABELS[name],
    apps: GROUP_APP_ACCESS[name] || [],
    permissions: GROUP_DEFAULT_PERMISSIONS[name] || [],
  })
)
